"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Use to wrap the content of an `<ExpansionPanel>`. The content may
 * include `<ExpansionPanelContentBody>` and `<ExpansionPanelContentActions>`.
 */


var ExpansionPanelContent = function (_React$Component) {
  _inherits(ExpansionPanelContent, _React$Component);

  function ExpansionPanelContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ExpansionPanelContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ExpansionPanelContent.__proto__ || Object.getPrototypeOf(ExpansionPanelContent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: undefined
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ExpansionPanelContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setHeight(this.props.expanded);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.expanded !== prevProps.expanded) {
        this.setHeight(this.props.expanded);
      }
    }
  }, {
    key: "setHeight",
    value: function setHeight(expanded) {
      if (this.content) {
        var expandedHeight = this.props.expandedHeight;
        this.setState({
          height: expanded ? typeof expandedHeight !== "undefined" ? expandedHeight : this.content.scrollHeight : 0
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          expanded = _props.expanded,
          style = _props.style,
          expandedHeight = _props.expandedHeight,
          children = _props.children,
          other = _objectWithoutProperties(_props, ["className", "expanded", "style", "expandedHeight", "children"]);

      return _react2.default.createElement("div", _extends({
        className: (0, _classnames2.default)("cdk-expansion-panel__content", className),
        ref: function ref(content) {
          _this2.content = content;
        },
        style: Object.assign({
          height: this.state.height
        }, style)
      }, other), children);
    }
  }]);

  return ExpansionPanelContent;
}(_react2.default.Component);

ExpansionPanelContent.propTypes = {
  /**
   * When the content is expanded the height is adjusted to take the
   * content into account. If you want to override this then specify
   * a suitable height either in pixels or a CSS value such as "auto".
   */
  expandedHeight: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
};
exports.default = ExpansionPanelContent;